import React from 'react';
import QueueList from './QueueList';
import * as API from 'modules/app/API.js';

class QueuesTab extends React.Component {
    constructor(props) {
        super(props);

        this.state = this.initialState(props);
    }

    initialState(props) {
        return {
            queueList: [],
            loading: false
        };
    }

    componentDidMount() {
        var rq = {};

        this.setState({ loading: true });

        API.App.get('/console/getQueues', rq, {
            success: (sr) => {
                this.setState({
                    queueList: sr.data.queueList,
                    loading: false
                });
            }
        });
    }

    render() {
        if (this.state.loading)
            return (<p>Loading...</p>);

        return (
            <QueueList queueList={this.state.queueList} />
        );
    }
}

export default QueuesTab;



// WEBPACK FOOTER //
// ./src/areas/admin/console/queues/QueuesTab.js